import React, { useMemo } from "react";
import useSWR from "swr";

import { CATEGORIES } from "../../api/categories";

import { Screen } from "components/Screen";
import { SearchBox } from "components/SearchBox";
import { useStateManager } from "utils/useStateManager";

type Props = {
  onSubmit: (exists?: boolean) => Promise<void>;
  onBack: () => void;
};

export const Allergens: React.FC<Props> = (props) => {
  const { allergens, setAllergens } = useStateManager();
  const { data: ingredients = [], isValidating } = useSWR<
    {
      key: string;
      custom_наименование: string;
    }[]
  >([CATEGORIES.INGREDIENTS, 345]);

  const handleChange = (search: string, values: string[]) => {
    setAllergens(
      allergens.concat({
        custom_текст_поиска: search,
        custom_ингредиенты_аллергены: values,
      })
    );
  };

  const handleRemoveItem = (key: string) => {
    setAllergens(
      allergens
        .map((group) => ({
          ...group,
          custom_ингредиенты_аллергены:
            group.custom_ингредиенты_аллергены.filter((item) => item !== key),
        }))
        .filter((group) => group.custom_ингредиенты_аллергены.length)
    );
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    await props.onSubmit();
  };

  const options = useMemo(
    () =>
      ingredients.map((item) => ({
        value: item.key,
        label: item.custom_наименование,
      })),
    [ingredients]
  );
  const value = useMemo(
    () =>
      allergens.reduce((acc, item) => {
        acc.push(...item.custom_ингредиенты_аллергены);
        return acc;
      }, [] as string[]),
    [allergens]
  );

  return (
    <Screen
      title="Аллергические реакции"
      buttonTitle={
        allergens.length === 0 ? "У меня нет пищевой аллергии" : "Продолжить"
      }
      onSubmit={handleSubmit}
      onBack={props.onBack}
    >
      <SearchBox
        title="У вас есть пищевая аллергия?"
        placeholder="Введите название аллергена"
        isLoading={isValidating}
        options={options}
        onChange={handleChange}
        onRemoveItem={handleRemoveItem}
        minSearchLength={2}
        value={value}
      />
    </Screen>
  );
};
